$(document).ready(function(){   
    $(window).resize(resize);
    resize();

    $('.mobile').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        prevArrow:'',
        nextArrow:'',
        draggable: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                adaptiveHeight: true,
                draggable: false
                },
            },
            {
                breakpoint: 769,
                settings: {
                slidesToShow: 1, 
                dots: true,
                slidesToScroll: 1,
                draggable: false,
                swipeToSlide: false,
                touchMove: false
                },
            }
        ]
    }); 
    $('.my-homepage-slider_mobile').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        prevArrow:'',
        nextArrow:'',
        draggable: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                adaptiveHeight: true,
                draggable: false
                },
            },
            {
                breakpoint: 767,
                settings: {
                slidesToShow: 1, 
                dots: true,
                slidesToScroll: 1,
                arrows: false
                },
            }
        ]
    });

    if($('.mobile').find('.slick-dots li').length > 1){
        $('.mobile').find('.slick-dots li').show();
    }else {
        $('.mobile').find('.slick-dots li').hide();
    }



    // var $status = $('.pagingInfo');
    // var $slickElement = $('.my-homepage-slider');
    // $slickElement.on('init', function(event, slick, currentSlide, nextSlide){
    //     $status.text(i + '/' + slick.slideCount);
    // })

    // $slickElement.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
    //     var i = (currentSlide ? currentSlide : 0) + 1;
    //     $status.text(i + '/' + slick.slideCount);
    // });

    $('#slider-before-after').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        prevArrow:'<button type="button" class="slick-arrow slick-before--prev pull-left"><img src="https://cdn.shopify.com/s/files/1/2093/5961/files/before_small_arrow.png?v=1586324391"></button>',
        nextArrow:'<button type="button" class="slick-arrow slick-after--next pull-right"><img src="https://cdn.shopify.com/s/files/1/2093/5961/files/after_small_arrow.png?v=1586324391"></button>',
        draggable: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    draggable: false,
                    swipeToSlide: false,
                    touchMove: false
                },
            },
            {
                breakpoint: 769,
                settings: {
                    touchThreshold: 20,
                    slidesToShow: 1,
                    dots: true,
                    prevArrow:'',
                    nextArrow: '',
                    slidesToScroll: 1,
                    draggable: false,
                    swipeToSlide: false,
                    touchMove: false
                },
            }
        ]
    });
    if($('#slider-before-after').find('.slick-dots li').length > 1){
        $('#slider-before-after').find('.slick-dots li').show();
    }else {
        $('#slider-before-after').find('.slick-dots li').hide();
    }


    var $slider = $('.slider');

    if ($slider.length) {
        var currentSlide;
        var slidesCount;
        var sliderCounter = document.createElement('div');
        sliderCounter.classList.add('slider__counter');

        var updateSliderCounter = function(slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            $(sliderCounter).text(currentSlide + '/' +slidesCount)
        };

        $slider.on('init', function(event, slick) {
            $slider.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $slider.on('afterChange', function(event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow:'<button type="button" class="slick-arrow new-slick-arrow--prev pull-left"><img src="https://cdn.shopify.com/s/files/1/2093/5961/files/left_arrow.png?v=1585548536"></button>',
            nextArrow:'<button type="button" class="slick-arrow new-slick-arrow--next pull-right"><img src="https://cdn.shopify.com/s/files/1/2093/5961/files/right_arrow.png?v=1585548536"></button>',
            dots: false,
            draggable: false,
            swipeToSlide: false,
            touchMove: false,
            responsive: [
                { 
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        prevArrow:'',
                        nextArrow: '',
                        dots: true
                    },
                }
            ]
        });
    }

    $('.card_accordioun').each(function(i, e){
        $(this).find(".card-header").attr("href", "#id_" + i);
        $(this).find(".card-body").attr("id", "id_" + i);
    });

    $('.faq_view_more_btn').click(function(){
        $('.cus_accordion').find('.card').addClass('increase_height');
    });

    if ($(window).width() > 1200) {
        target = $('.current_product_detail').height();
        $('.current_product_detail_right').height(target);
    }

    
    var freq_bought = [];
    var product_sum = 0;
    var net_price = 0;
    var quantity_product = 4;
    $('.js-frequent-product-checkbox').on('click',function(){
        if($(this).is(":checked")){
            freq_bought.push($(this).attr('data-variant-id'));
            var product_price = Number($(this).attr('product-price').replace(',',''));
            if($(this).attr('cpap-id') == $('.current-product-li').attr('pro-id')){
                product_sum = product_sum + product_price ;
                console.log('product_price '+product_sum);
            } else {
                product_sum += product_price;
            }

            var prod_value_current = $('.current-product-li').attr('prod-price-current').replace(',','');
            var prod_value_current_num = Number(prod_value_current);
                
            if($('.add-ons-total').attr('product-id') == $('.current-product-li').attr('pro-id')){
                var prod_sum_total = prod_value_current_num + product_sum;
            } else {
                var prod_sum_total = prod_value_current_num + product_sum;
            }

            net_price = prod_sum_total;
            $('.add-ons').html(Shopify.format_money(product_sum * 100,currency_format));
            $('.add-ons-total').html(Shopify.format_money(prod_sum_total * 100,currency_format));
            
            quantity_product += 1;
            $('.addtocart-main-price').attr('value','ADD '+ quantity_product +' ITEMS TO CART');
        } else {
            var index = freq_bought.indexOf($(this).attr('data-variant-id'));
            if (index !== -1) {
                freq_bought.splice(index, 1);
            }
            var product_price = Number($(this).attr('product-price').replace(',',''));
            if($(this).attr('cpap-id') == $('.current-product-li').attr('pro-id')){
                product_sum = Math.abs(product_sum - product_price);
            } else {
                product_sum = Math.abs(product_sum - product_price);
            }

            var prod_value_current = $('.current-product-li').attr('prod-price-current').replace(',','');
            var prod_value_current_num = Number(prod_value_current);
            if($(this).attr('cpap-id') == $('.current-product-li').attr('pro-id')){
                net_price = Math.abs(net_price - product_price);
            } else {
                net_price = net_price - product_price;
            }
            $('.add-ons').html(Shopify.format_money(product_sum * 100,currency_format));
            $('.add-ons-total').html(Shopify.format_money(net_price * 100,currency_format)); 

            quantity_product -= 1;
            $('.addtocart-main-price').attr('value','ADD '+ quantity_product +' ITEMS TO CART');
        }
    });

    setTimeout( function(){ 
        var prod_price_load = 0;
        var current_prod_price = $('.current-product-li').attr('prod-price-current').replace(',','');
        var current_prod_price_num = parseFloat(current_prod_price);

        $('.for-loop-li').each(function(){
    
            freq_bought.push($(this).find('.js-frequent-product-checkbox').attr('data-variant-id'));
    
            var prod_price = $(this).find('.new_product_price_second').attr('data-price').replace(',','');
            //console.log('prod_price '+prod_price);
           // console.log(typeof(prod_price));
            // var prod_price_num = parseFloat(prod_price);
            if($(this).find('.js-frequent-product-checkbox').attr('cpap-id') == $('.current-product-li').attr('pro-id')){
                var prod_price_num = parseFloat(prod_price);
            }
            else{
                var prod_price_num = parseFloat(prod_price);
            }
            //console.log('prod_price_num '+prod_price_num);
           // console.log(typeof(prod_price_num));
            prod_price_load = prod_price_load + prod_price_num;
          //  console.log('prod_price_load '+prod_price_load);
          //  console.log(typeof(prod_price_load));
            product_sum = prod_price_load;
            $('.add-ons').html(Shopify.format_money(prod_price_load * 100,currency_format));
            if($('.add-ons-total').attr('product-id') == $('.current-product-li').attr('pro-id')){
                var final_price = prod_price_load+current_prod_price_num;
            }
            else{
                var final_price = prod_price_load+current_prod_price_num;
            }
            net_price = final_price;
            console.log('net_price '+net_price);
            $('.add-ons-total').html(Shopify.format_money(final_price * 100,currency_format));
        });
    }, 500 );
    // frequently add products
    $("#frequently-added-form").submit(function(event){
        // console.log($('.js-frequent-product-checkbox'));
        var productArray = [];
        var addToCart = true;
          if ( Elevatione.DISCOUNTEDPRODUCT_ID ) {
            productArray.push([Elevatione.DISCOUNTEDPRODUCT_ID, 1]);
          } 

        productArray.push([$('.current-product-li').attr('data-variant-id'),1]);
        $('.js-frequent-product-checkbox').each(function(){
            // console.log($(this));
            var id = $(this).attr('data-variant-id');
            var quantity = 1;
            var inStock = 1;

            if($(this).is(":checked") && inStock > 0) {
                addToCart = true;
                productArray.push([id, quantity]);
            }

            if($(this).is(":checked") && !(inStock > 0)) {
                $(this).closest(".frequent-checkbox").siblings(".frequent-variant-wrapper").append("<p class='frequent-notinstock'>Selected variant combination not in stock</p>")
                addToCart = false;
                return false;
            }
        });
        if(addToCart == true) {
            for(let i = 0; i < productArray.length; i++) {
                $(this).find('.load-3p').css({"display":"block"});
                CartJS.addItem(Number(productArray[i][0]), productArray[i][1], {
                    "success": function(data, textStatus, jqXHR) {
                        $('.js-add-more-items').val('');
                        $('.line').css({"display":"inline-block"});
                        $(".frequent-adding-cart-text").addClass("active");
                        $(".frequent-add-cart-text").removeClass("active");
                    },
                    "error": function(jqXHR, textStatus, errorThrown) {
                        console.log('Error: ' + errorThrown + '!');
                    }
                });
            }
        }

    
        $(document).on('cart.requestComplete', function(event, cart) {
            $('.Header__CartCount').html(cart.item_count);
            $(".frequent-go-cart-text").addClass("active");
            $(".frequent-adding-cart-text").removeClass("active");
            window.location.href = '/cart';
        });
        event.preventDefault();
    });
    $('.technology-benefits').scroll(function(){
        var asd = $(this).scrollTop();
        console.log(asd)
    })
    $('#scroll-item-desc-1').removeClass('hideScrollItem');
    $('#scrollable-item-image-1').removeClass('hideScrollItem');
    $('#scrollable-item-text-1').addClass('boldscrollitem');
    $('#scroll-item-active-line-1').removeClass('hideScrollItem');
    $('#scroll-item-active-bullet-1').removeClass('hideScrollItem');
    $('#scrollable-item-text-1').css('opacity', '1');
    $('#upcoming-events-img-wrapper-1').removeClass('hideScrollItem');
    
    // Scroll Magic 
    var controller = new ScrollMagic.Controller();
    var scene = new ScrollMagic.Scene({
        triggerElement: ".how-use-scroll-fixed",
        triggerHook: 0,
        duration: '100%'
    })
    .setPin(".how-use-scroll-fixed")
    .on("progress", function (e) {
        if(e.progress>0 && e.progress <=0.1) {
            scrollableItem(1);
        } else if(e.progress>0.1 && e.progress <=0.2) {
            scrollableItem(2)
        } else if(e.progress>0.2 && e.progress <=0.3) {
            scrollableItem(3)
        } else if(e.progress>0.3 && e.progress <=0.4) {
            scrollableItem(4)
        } else if(e.progress>0.4 && e.progress <=0.5) {
            scrollableItem(5);
        } else if(e.progress>0.5 && e.progress <=0.6) {
            scrollableItem(6)
        } else if(e.progress>0.6 && e.progress <=0.7) {
            scrollableItem(7)
        } else if(e.progress>0.7 && e.progress <=0.8) {
            scrollableItem(8)
        } else if(e.progress>0.8 && e.progress <=0.9) {
            scrollableItem(9)
        } else if(e.progress>0.9 && e.progress <=1) {
            scrollableItem(10)
        }
    })
    .addTo(controller);

// ********** Elevation Second Phase Sushil's Sections Js Code Starts From Here *********** 
// New Peoduct Icon Slider
$('.icon-svg-wrapper').hover(function() {
    $(this).parent().find('.icon-description').toggleClass('show-icon-description');
});
$('.icon-svg-wrapper-tablet').click(function() {
    if(!$(this).parent().find('.icon-description').hasClass('show-icon-description-mobile')) {
        $('.icon-svg-wrapper-tablet').parent().find('.icon-description').removeClass('show-icon-description-mobile');
        $(this).parent().find('.icon-description').toggleClass('show-icon-description-mobile');
    }
});

$('#new-product-icon').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow:'<button type="button" class="slick-new-product-arrow new-product-icon-arrow--prev pull-left"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="15.092" height="30.771" viewBox="0 0 32.092 62.771"><path id="Path_6971" data-name="Path 6971" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(8569.738 5453.231) rotate(180)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    nextArrow:'<button type="button" class="slick-new-product-arrow new-product-icon-arrow--next pull-right"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="15.092" height="30.771" viewBox="0 0 32.092 62.771"><path id="Path_6472" data-name="Path 6472" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(-8537.646 -5390.46)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    dots: false,
    draggable: false
});

// Top University Slider
$('.top-university-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:'<button type="button" class="slick-new-product-university-arrow new-product-university-icon-arrow--prev pull-left"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="15.092" height="30.771" viewBox="0 0 32.092 62.771"><path id="Path_6971" data-name="Path 6971" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(8569.738 5453.231) rotate(180)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    nextArrow:'<button type="button" class="slick-new-product-university-arrow new-product-university-icon-arrow--next pull-right"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="15.092" height="30.771" viewBox="0 0 32.092 62.771"><path id="Path_6472" data-name="Path 6472" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(-8537.646 -5390.46)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    dots: false,
    draggable: false,
    responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          }
        }
      ]
});
if($('.top-university-carousel').find('.slick-dots li').length > 1){
    $('.top-university-carousel').find('.slick-dots li').show();
}else {
    $('.top-university-carousel').find('.slick-dots li').hide();
}



$('.university-card').hover(function(){
    $(this).css('box-shadow', '0px 0px 22px rgba(0,0,0,0.2)');
}, function(){
    $(this).css('box-shadow', '0px 0px 36px #0000000A');
});

// Peak Inside Section 
$('.peak-inside-carousel').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow:'<button type="button" class="slick-peak-inside-arrow peak-inside-icon-arrow--prev pull-left"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="23.092" height="38.771" viewBox="0 0 32.092 62.771"><path id="Path_6971" data-name="Path 6971" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(8569.738 5453.231) rotate(180)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    nextArrow:'<button type="button" class="slick-peak-inside-arrow peak-inside-icon-arrow--next pull-right"><i class=""><svg xmlns="http://www.w3.org/2000/svg" width="23.092" height="38.771" viewBox="0 0 32.092 62.771"><path id="Path_6472" data-name="Path 6472" d="M8538,5390.814l31.031,31.032L8538,5452.877" transform="translate(-8537.646 -5390.46)" fill="none" stroke="#707070" stroke-width="1"/></svg></i></button>',
    dots: false,
    draggable: false
});

$('.peak-inside-video-btn').on('click',function(){
    $('.js-play-btn-peak-inside').magnificPopup({
        type: 'iframe', 
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +
                '<div class="mfp-close"></div>' +
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
    
            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
    
                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }
    
                    src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                },
                gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                }
    
                // you may add here more sources
    
            },
    
            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });
});

});

function resize() {
    if ($(window).width() < 767) {
        $('.mobile_slide').addClass('mobile');
    } else {$('.mobile_slide').removeClass('mobile');}
}

// How to Use Section (Scroll Magic)

function getIdOnClick (elem) {
    var str=elem.id;
    var clickedNum =str.match(/(\d+)/);
    scrollableItem(clickedNum);
}

function scrollableItem(item) {
var windowWidth =$(window).width();

    if($('#scroll-item-active-line-'+ item).length ==1 ) {
        var $sidebar   = $(".section-scrollable-wrapper")
        if(item == 1) {
            $sidebar.scrollTop(0);
        } else if(item == 2) {
            if(windowWidth<=320){
                $sidebar.scrollTop(11);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(16);

            }
            else {
                $sidebar.scrollTop(30);

            }
        } else if(item == 3) {
            if(windowWidth<=320){
                $sidebar.scrollTop(22);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(32);

            }
            else {
                $sidebar.scrollTop(50);

            }
        } else if(item == 4) {
            if(windowWidth<=320){
                $sidebar.scrollTop(33);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(48);

            }
            else {
                $sidebar.scrollTop(70);
  
            }
        } else if(item == 5) {
            if(windowWidth<=320){
                $sidebar.scrollTop(44);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(64);

            }
            else {
                $sidebar.scrollTop(90);
   
            }
        } else if(item == 6) {
            if(windowWidth<=320){
                $sidebar.scrollTop(55);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(80);

            }
            else {
                $sidebar.scrollTop(110);

            }
        } else if(item == 7) {
            if(windowWidth<=320){
                $sidebar.scrollTop(66);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(96);

            }
            else {
                $sidebar.scrollTop(130);

            }
            $sidebar.scrollTop(130);
        } else if(item == 8) {
            if(windowWidth<=320){
                $sidebar.scrollTop(77);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(112);

            }
            else {
                $sidebar.scrollTop(150);
  
            }
        } else if(item == 9) {
            if(windowWidth<=320){
                $sidebar.scrollTop(88);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(128);

            }
            else {
                $sidebar.scrollTop(170);

            }
        } else if(item == 10) {
            if(windowWidth<=320){
                $sidebar.scrollTop(125);

            }else if(windowWidth >=375 && windowWidth<1024){
                $sidebar.scrollTop(155);

            }
            else {
                $sidebar.scrollTop(190);

            }
        }
        $('.section-description-wrapper').addClass('hideScrollItem');
        $('#scroll-item-desc-' + item).removeClass('hideScrollItem');
        $('.scrollable-item-active-line').addClass('hideScrollItem');
        $('.scrollable-item-active-bullet').addClass('hideScrollItem');
        $('#scroll-item-active-line-' + item).removeClass('hideScrollItem');
        $('#scroll-item-active-bullet-' + item).removeClass('hideScrollItem');
        $('.scrollable-item-image').addClass('hideScrollItem');
        $('#scrollable-item-image-' + item).removeClass('hideScrollItem');

        $('.scrollable-item-text-number').css('opacity', '0.6');
        $('#scrollable-item-text-'+ item).css('opacity', '1');
        $('.scrollable-item-text-number').removeClass('boldscrollitem');
        $('#scrollable-item-text-' + item).addClass('boldscrollitem');

        $('.upcoming-events-img-wrapper').addClass('hideScrollItem');
        $('#upcoming-events-img-wrapper-' + item).removeClass('hideScrollItem');
    }
}

// ********** Elevation Second Phase Sushil's Sections Js Code Ends Here *********** 